import BaseDownloadButton from 'components/atoms/download-button';
import NavigationHeader from 'components/molecules/navigation-header';
import withLoader from 'components/organisms/withLoader';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface OnboardingNavigationHeaderProps {
  hasPatients: boolean;
  totalPatients?: number;
  title: string;
  loading: boolean;
  onClick: () => void;
}

const OnboardingNavigationHeader: FC<OnboardingNavigationHeaderProps> = ({
  hasPatients,
  totalPatients,
  title,
  loading,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.header}>
      <NavigationHeader title={title}>
        <div className={s['right-wrapper']}>
          {typeof totalPatients !== 'undefined' && (
            <div className={s['total-patients']}>
              <p className={s['total-patients-title']}>
                {t('labels.totalPatients')}:
              </p>
              <p className={s['total-patients-value']}>{totalPatients}</p>
            </div>
          )}
          {withLoader(
            loading,
            <BaseDownloadButton onClick={onClick} disabled={!hasPatients} />,
          )}
        </div>
      </NavigationHeader>
    </div>
  );
};
export default OnboardingNavigationHeader;
